import {useNavigate} from 'react-router-dom';
import {toast} from '../../hooks/useToast';
import {Post} from '../../types';

// Ticking a to-do off offers "Tell it": the journal keeps the record of what was done, the list
// is only the prompt. The new tell is filled in with the job's plant, place and the kind it
// becomes (useTellPrefill applies it to an untouched draft).
export function useTellIt() {
    const navigate = useNavigate();
    return (todo: Post, repeated: boolean) => {
        const q = new URLSearchParams();
        if (todo.plants[0]) q.set('plant', todo.plants[0].label);
        if (todo.place) q.set('place', todo.place.id);
        if (todo.tellKind) q.set('kind', todo.tellKind);
        toast.success(repeated ? `Done. Back on the list ${todo.repeat === 'weekly' ? 'next week' : 'next year'}.` : 'Done.', {
            action: {label: 'Tell it', onClick: () => navigate(`/tell/new${q.toString() ? `?${q.toString()}` : ''}`)}
        });
    };
}
